const sumToPeriod = (periods, id) => {
  let sum = 0;
  for (let i = 0; i < periods.findIndex((x) => x.id === id) || 0; i++) {
    sum += periods[i].duration;
  }
  return sum * 60;
};

export default sumToPeriod;
